import { Add, Minus } from '@mos-cat/ds-icons';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { VisuallyHidden, unstable_useId as useId } from 'reakit';
import { Box } from '../Box/Box';
import { StepperFieldButton } from './components/StepperFieldButton';
import { StepperFieldInput } from './components/StepperFieldInput';
import { StepperFieldWrapper } from './components/StepperFieldWrapper';
import type { ForwardRefType, StepperFieldProps } from './types';

export const StepperField = forwardRef<HTMLInputElement, StepperFieldProps>(
  ({ ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle<ForwardRefType, ForwardRefType>(
      ref,
      () => inputRef.current
    );

    const generateId = useId({ id: props.id });

    const handleStepChange = (isIncrement: boolean) => {
      const inputElement = inputRef.current;
      if (!inputElement) return;

      if (isIncrement) {
        inputElement.stepUp();
      } else {
        inputElement.stepDown();
      }

      const event = new Event('input', { bubbles: true });
      inputElement.dispatchEvent(event);
    };

    const handleDecrement = () => {
      handleStepChange(false);
    };

    const handleIncrement = () => {
      handleStepChange(true);
    };

    return (
      <StepperFieldWrapper disabled={props.disabled} hasError={props.hasError}>
        <StepperFieldButton
          onClick={handleDecrement}
          aria-describedby={generateId.id}
          disabled={props.disabled}
        >
          <Minus aria-hidden="true" />
          <VisuallyHidden>Уменьшить</VisuallyHidden>
        </StepperFieldButton>
        <Box flexGrow="40" className="input_wrapper">
          <StepperFieldInput
            id={generateId.id}
            width={1}
            ref={inputRef}
            disabled={props.disabled}
            {...props}
          />
        </Box>
        <StepperFieldButton
          disabled={props.disabled}
          onClick={handleIncrement}
          aria-describedby={generateId.id}
        >
          <Add aria-hidden="true" />
          <VisuallyHidden>Увеличить</VisuallyHidden>
        </StepperFieldButton>
      </StepperFieldWrapper>
    );
  }
);
